export default __webpack_public_path__ + "static/media/WinterClothes_05.78757ced.png";